<co-toast
  *ngFor="let toast of toasts$ | async"
  [message]="toast.message"
  [type]="toast.type"
  [duration]="toast.duration"
  [errorMessage]="toast.errorMessage"
  (remove)="onRemove(toast)"
></co-toast>
